import script from "./ResidentFinancialSummaryCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ResidentFinancialSummaryCard.vue?vue&type=script&setup=true&lang=js"

import "./ResidentFinancialSummaryCard.vue?vue&type=style&index=0&id=3685ffe2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3685ffe2"]])

export default __exports__